import type { IntakeFormPayload, IntakeResponse } from '../types';

const BASE = import.meta.env.VITE_API_URL ?? 'http://localhost:8000';

export async function submitIntake(payload: IntakeFormPayload): Promise<IntakeResponse> {
  const res = await fetch(`${BASE}/api/v1/intake`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail ?? `Intake failed: ${res.status}`);
  }
  return res.json();
}

export async function uploadMedia(
  signedUrl: string,
  file: File,
  onProgress?: (pct: number) => void
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', signedUrl);
    xhr.setRequestHeader('Content-Type', file.type);
    if (onProgress) {
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
      };
    }
    xhr.onload = () => (xhr.status < 300 ? resolve() : reject(new Error(`Upload failed: ${xhr.status}`)));
    xhr.onerror = () => reject(new Error('Upload network error'));
    xhr.send(file);
  });
}

export async function triggerAnalysis(jobId: string): Promise<void> {
  const res = await fetch(`${BASE}/api/v1/analysis/${jobId}/run`, { method: 'POST' });
  if (!res.ok) throw new Error(`Analysis trigger failed: ${res.status}`);
}

export async function pollJobStatus(jobId: string) {
  const res = await fetch(`${BASE}/api/v1/analysis/${jobId}/status`);
  if (!res.ok) throw new Error(`Status check failed: ${res.status}`);
  return res.json();
}

export async function fetchReport(jobId: string) {
  const res = await fetch(`${BASE}/api/v1/reports/${jobId}`);
  if (!res.ok) throw new Error(`Report fetch failed: ${res.status}`);
  return res.json();
}
